// =============================================================================
//  Copyright : 2024 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : transcription activity
// =============================================================================
// ---Third-party imports
import React from 'react'

// ---Framework imports
import {Actions} from 'uix/registries'
import log from 'uix/logging'
import {useApi} from 'uix/hooks'

// ---Local imports
import {TranscriptionLayout, BasicButton} from '../components'
import {useApiWithPuid} from '../hooks'

// ---Exports
export const TranscriptionActivity = ({i18n}) => {
  let {data} = useApiWithPuid('filter/getTranscriptionActivities')
  let activeItems = data?.transcriberActivity.activeItems || []
  let activity = 'No activity recorded'
  let translateState = state => {
    let s = {6: 'toresume', 4: 'released', 3: 'torelease', 1: 'tocheck'}[state]
    return i18n.span(`tr_state_${s}`)
  }
  if (activeItems.length !== 0) {
    activity = activeItems.map(({otid, caption, activePages}) => {
      let pages = activePages.map(page => (
        <tr key={page.otid}>
          <td>{page.caption}</td>
          <td>{page.ts}</td>
          <td>{translateState(page.state)}</td>
          <td>
            <BasicButton icon="edit" link={{tabname: 'wiki', id: page.otid}} />
            <BasicButton icon="check" onClick={() => '/bau/action/setCheckpoint?otid=2048820'} />
            <BasicButton icon="eye" onClick={() => '/bau/content/pagetext/2048820'} />
          </td>
        </tr>
      ))

      return (
        <div key={otid}>
          <h2>{caption}</h2>
          <table>
            <thead>
              <tr>
                <td>{i18n.span('page')}</td>
                <td>{i18n.span('lastModifiedDate')}</td>
                <td>{i18n.span('state')}</td>
                <td>{i18n.span('action')}</td>
              </tr>
            </thead>
            <tbody>{pages}</tbody>
          </table>
        </div>
      )
    })
  }
  return <TranscriptionLayout>{activity}</TranscriptionLayout>
}
